(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@alifd/next"), require("react-dom"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@alifd/next", "react-dom", "moment"], factory);
	else if(typeof exports === 'object')
		exports["CbayelLowcodeMaterials"] = factory(require("react"), require("@alifd/next"), require("react-dom"), require("moment"));
	else
		root["CbayelLowcodeMaterials"] = factory(root["React"], root["Next"], root["ReactDOM"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__34__, __WEBPACK_EXTERNAL_MODULE__51__) {
return 